import Vue from 'vue'

/**
 * 使用方法：
 * 1. 在main.js中,使用import引入即可
 * 2. 给dialog加上 v-dialogDrag 指令就可以实现弹窗的全屏和拉伸了
 * 3. 添加 v-dialogDrag 实现弹窗拖拽+水平方向伸缩
 */

Vue.directive('dialogDrag', {
  bind(el, binding, vnode, oldVnode) {
    //初始非全屏
    let isFullScreen = false;

    //当前宽高
    let nowWidth = 0;
    let nowHight = 0;

    //当前顶部高度
    let nowMarginTop = 0;

    //获取弹框头部
    const dialogHeaderEl = el.querySelector('.el-dialog__header');
    // 可点击全屏
    const dialogHeaderFull = el.querySelector('.esp_full_btn');

    //弹窗
    const dragDom = el.querySelector('.el-dialog');

    //给弹窗加上overflow auto；不然缩小时框内的标签可能超出dialog；
    dragDom.style.overflow = "auto";

    //清除选择头部文字效果
    //dialogHeaderEl.onselectstart = new Function("return false");

    //头部加上可拖动cursor
    dialogHeaderEl.style.cursor = 'move';

    // 获取原有属性 ie dom元素.currentStyle 火狐谷歌 window.getComputedStyle(dom元素, null);
    const sty = dragDom.currentStyle || window.getComputedStyle(dragDom, null);

    let moveDown = (e) => {
      // 鼠标按下，计算当前元素距离可视区的距离
      const disX = e.clientX - dialogHeaderEl.offsetLeft;
      const disY = e.clientY - dialogHeaderEl.offsetTop;

      // 获取到的值带px 正则匹配替换
      let styL, styT;

      // 注意在ie中 第一次获取到的值为组件自带50% 移动之后赋值为px
      if (sty.left.includes('%')) {
        styL = +document.body.clientWidth * (+sty.left.replace(/\%/g, '') / 100);
        styT = +document.body.clientHeight * (+sty.top.replace(/\%/g, '') / 100);
      } else {
        styL = +sty.left.replace(/\px/g, '');
        styT = +sty.top.replace(/\px/g, '');
      }

      document.onmousemove = function (e) {
        // 通过事件委托，计算移动的距离
        const l = e.clientX - disX;
        const t = e.clientY - disY;

        // 移动当前元素
        dragDom.style.left = `${l + styL}px`;
        dragDom.style.top = `${t + styT}px`;

        //将此时的位置传出去
        //binding.value({x:e.pageX,y:e.pageY})
      };

      document.onmouseup = function (e) {
        document.onmousemove = null;
        document.onmouseup = null;
      };
    };

    dialogHeaderEl.onmousedown = moveDown;

    //双击头部全屏效果
    dialogHeaderFull.onclick = (e) => {
      if (isFullScreen == false) {
        nowWidth = dragDom.style.width;
        nowHight = dragDom.style.height;

        nowMarginTop = dragDom.style.marginTop;
        dragDom.style.left = 0;
        dragDom.style.top = 0;
        dragDom.style.height = "100%";
        dragDom.style.width = "100%";
        dragDom.style.marginTop = 0;
        isFullScreen = true;
        dialogHeaderEl.style.cursor = 'initial';
        dialogHeaderEl.onmousedown = null;
      } else {
        dragDom.style.width = nowWidth;
        dragDom.style.height = nowHight;
        dragDom.style.marginTop = nowMarginTop;
        isFullScreen = false;
        dialogHeaderEl.style.cursor = 'move';
        dialogHeaderEl.onmousedown = moveDown;
      }
    };
  }
});



// WEBPACK FOOTER //
// ./src/assets/dialog/move_full.js